// extracted by mini-css-extract-plugin
export default {"productGallery":"LF-z","inQuickShop":"MF-z"};